export const config = {
    app: {
        namespace: "GBK"
    },
    assets: {
        spriteUrl: "/dist/styles/assets/svgsprite/icons.svg"
    }
};
